import * as core from '../../../../../../../core'

import { query } from './traceability-matrix-table.query'

export const RESOURCE = {
  payload: {
    alias: 'traceability-matrix.table',
    description:
      'Every requirement with its coverage state, build, test, review, and docs evidence',
    name: 'Traceability Matrix Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
